"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialRedirect = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
// @ts-ignore
const query_string_1 = require("query-string");
const types_1 = require("../types");
const server_types_1 = require("../server-types");
const auth_1 = require("../logic/auth");
const SocialRedirect = ({ t, authManager, onSuccess, onError, }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const [isProcessing, setIsProcessing] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    const [shouldRedirect, setShouldRedirect] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        // When the OAuth popup opened by oAuthLogin (utils/oauth.ts) lands on
        // /oauth2callback, the parent window is polling the popup URL to extract
        // the authorization code itself and will call /api/authenticate. If we
        // also process the callback here, both windows race to exchange the same
        // one-time grantToken with Google; the loser gets `invalid_grant`, which
        // the backend surfaces as a 500 with key `grantToken`, type INVALID_VALUE.
        // Skip processing when we're in a popup — leave isProcessing true so the
        // user sees "Processing..." until the parent closes us.
        if (typeof window !== 'undefined' && window.opener) {
            return;
        }
        const processOAuthCallback = async () => {
            try {
                const query = (0, query_string_1.parse)(location.search);
                console.log('SocialRedirect query params:', query);
                // Check for OAuth errors
                if (query.error) {
                    console.error('OAuth error:', query.error);
                    setError(`OAuth error: ${query.error}`);
                    onError?.(query.error);
                    setIsProcessing(false);
                    return;
                }
                // Extract authorization code
                const code = query.code;
                if (!code) {
                    console.error('No authorization code received');
                    setError('No authorization code received');
                    onError?.('No authorization code received');
                    setIsProcessing(false);
                    return;
                }
                // Parse state to determine provider and origin
                let state = {};
                if (query.state) {
                    try {
                        state = JSON.parse(decodeURIComponent(query.state));
                    }
                    catch (e) {
                        console.warn('Failed to parse state:', e);
                    }
                }
                // Determine OAuth provider (default to Google if not specified)
                let provider = types_1.SOCIAL.GOOGLE;
                if (state.provider && (0, types_1.isSocial)(state.provider)) {
                    provider = state.provider;
                }
                // Call the authentication endpoint with the authorization code
                const response = await authManager.authenticate({
                    // Required fields for StateDerivedAuthDataInterface
                    sourceApp: server_types_1.TargetSite.Hub, // Set appropriate target site
                    workEmail: undefined,
                    userSocialLinkToken: undefined,
                    newsletterAccepted: false,
                    EmailDomain_id: undefined,
                    tosApproved: 1, // Required for social login
                    // StateAuthParamsType fields
                    socialType: provider,
                    grantToken: code,
                }, {}, // tokens
                false, // needsAuth
                state.origin || '/');
                if (response.success && response.payload?.success) {
                    // Set authentication state - this triggers the auth channel event
                    const userAuth = response.payload.userAuth;
                    if (userAuth && userAuth.auth && userAuth.authorization) {
                        (0, auth_1.setAuth)({
                            auth: userAuth.auth,
                            authorization: userAuth.authorization,
                        }, provider);
                    }
                    onSuccess?.(response);
                    // Redirect to the intended destination or default route
                    setShouldRedirect(true);
                }
                else {
                    const errorMessage = response.payload?.message ||
                        response.payload?.userAuth?.message ||
                        'Authentication failed';
                    console.error('Authentication failed:', errorMessage);
                    setError(errorMessage);
                    onError?.(errorMessage);
                }
            }
            catch (error) {
                console.error('Error processing OAuth callback:', error);
                const errorMessage = error instanceof Error
                    ? error.message
                    : 'Unknown error occurred';
                setError(errorMessage);
                onError?.(errorMessage);
            }
            finally {
                setIsProcessing(false);
            }
        };
        processOAuthCallback();
    }, [location.search, authManager, onSuccess, onError]);
    // Handle errors - redirect to login
    if (error && !isProcessing) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/login", push: false });
    }
    // Handle successful authentication - redirect to default route
    if (shouldRedirect) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/", push: false });
    }
    // Show processing state
    return (react_1.default.createElement("section", { style: { textAlign: 'center', padding: '2rem' } }, isProcessing ? (react_1.default.createElement("div", null,
        react_1.default.createElement("div", null, t `Processing authentication...`),
        react_1.default.createElement("div", { style: { marginTop: '1rem' } }, t `Please wait while we complete your login.`))) : (react_1.default.createElement("div", null, t `Success! Wait for redirect`))));
};
exports.SocialRedirect = SocialRedirect;
//# sourceMappingURL=SocialRedirect.js.map